import { Component, ErrorInfo, ReactNode } from 'react'
import ErrorState from '../error-state/ErrorState'

interface ISectionBoundaryProps {
  children: ReactNode
  // What failed, when the generic "could not load the data" does not fit
  message?: string
}

interface ISectionBoundaryState {
  failed: boolean
}

// A crash inside one section shows an error in that section only. A single
// section getting data it did not expect used to take the whole page down to
// the router error screen.
class SectionBoundary extends Component<ISectionBoundaryProps, ISectionBoundaryState> {
  state: ISectionBoundaryState = { failed: false }

  static getDerivedStateFromError(): ISectionBoundaryState {
    return { failed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // the only diagnostic surface until an error tracker is added
    console.error('[section-boundary]', error, info.componentStack)
  }

  render() {
    if (this.state.failed) {
      return (
        <ErrorState message={this.props.message} onRetry={() => this.setState({ failed: false })} />
      )
    }
    return this.props.children
  }
}

export default SectionBoundary
